// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_tsx_errorPage__L7M2d"};